module.exports = __webpack_public_path__ + "static/img/portfoliosmith-login.0820f5d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfoliosmith-login.svg
// module id = kUjs
// module chunks = 1